import React, { useState } from 'react';
import './NewsletterSection.css';

function NewsletterSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  // PASTE YOUR GOOGLE SCRIPT URL HERE
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwPGhmrbwsgMnVcLTWnZeT3ZJh1XqlS2KHEXHU3V0qRnvayFxMNsVcsyBXFFcIhDKJZ/exec";

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload

    if (email.trim() !== '') {
      setIsLoading(true);

      // Create Form Data to send
      const formData = new FormData();
      formData.append('email', email);

      fetch(SCRIPT_URL, {
        method: 'POST',
        body: formData,
      })
      .then(response => {
         // Google scripts sometimes return opaque responses, but if it doesn't fail, we assume success
         console.log("Success!", response);
         setIsSubmitted(true);
         setIsLoading(false);
      })
      .catch(error => {
        console.error('Error!', error.message);
        alert("Something went wrong. Please try again.");
        setIsLoading(false);
      });

    } else {
      alert("Please enter an email address first!");
    }
  };

  return (
    <div className="newsletter-section" id="newsletter-signup">
      {!isSubmitted ? (
        <div className="newsletter-card">
          <div className="newsletter-left">
            <h2>Can’t wait for us to launch? Us too!</h2>
            <p>Stay updated with our newsletter.</p>
          </div>

          <div className="newsletter-right">
            <input 
              type="email" 
              placeholder="Enter your email" 
              className="newsletter-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading} // Disable while sending
            />
            <button 
              className="newsletter-button" 
              onClick={handleSubmit}
              disabled={isLoading} // Disable while sending
            >
              {isLoading ? "Sending..." : "Submit"}
            </button>
          </div>
        </div>
      ) : (
        <div className="newsletter-card submitted-card">
          <div className="success-message">
            <h2>You're in!</h2>
            <p>Stay updated with our newsletter.</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default NewsletterSection;
